import { ExpressionValue } from "../../ExpressionValue";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { BaseStringExpression } from "./BaseString";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringProperExpression extends BaseStringExpression {
    readonly __type: string = "String Proper";
    readonly __ruleName: string = "Proper";
    value1: ExpressionValue;

    constructor() {
        super();

        this.value1 = ExpressionValue.createExpressionValue(this, "stringValue", new StringDataDefinition());
    }

    // eslint-disable-next-line
    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        throw new Error("Method not implemented.");
    }
}
